// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LanguageSwitcher-module__root--a0GLc {
    display: inline-flex;
    gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/system/components/LanguageSwitcher/LanguageSwitcher.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,SAAS;AACb","sourcesContent":[".root {\n    display: inline-flex;\n    gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `LanguageSwitcher-module__root--a0GLc`
};
export default ___CSS_LOADER_EXPORT___;
